import React from 'react'
import { Platform, StyleSheet, View } from 'react-native'

const MultiSliderDefaultMarker = ({
  disabledMarkerStyle,
  enabled,
  markerStyle,
  pressed,
  pressedMarkerStyle,
}) => {
  return (
    <View
      style={
        enabled
          ? [
              defaultMarkerStyles.markerStyle,
              markerStyle,
              pressed && defaultMarkerStyles.pressedMarkerStyle,
              pressed && pressedMarkerStyle,
            ]
          : [defaultMarkerStyles.markerStyle, defaultMarkerStyles.disabled, disabledMarkerStyle]
      }
    />
  )
}

const defaultMarkerStyles = StyleSheet.create({
  markerStyle: {
    ...Platform.select({
      ios: {
        height: 30,
        width: 30,
        borderRadius: 30,
        borderWidth: 1,
        borderColor: '#DDDDDD',
        backgroundColor: '#FFFFFF',
        shadowColor: '#000000',
        shadowOffset: {
          width: 0,
          height: 3,
        },
        shadowRadius: 1,
        shadowOpacity: 0.2,
      },
      android: {
        height: 12,
        width: 12,
        borderRadius: 12,
        backgroundColor: '#0D8675',
      },
      web: {
        height: 30,
        width: 30,
        borderRadius: 30,
        borderWidth: 1,
        borderColor: '#DDDDDD',
        backgroundColor: '#FFFFFF',
        shadowColor: '#000000',
        shadowOffset: {
          width: 0,
          height: 3,
        },
        shadowRadius: 1,
        shadowOpacity: 0.2,
      },
    }),
  },
  pressedMarkerStyle: {
    ...Platform.select({
      web: {},
      ios: {},
      android: {
        height: 20,
        width: 20,
        borderRadius: 20,
      },
    }),
  },
  disabled: {
    backgroundColor: '#d3d3d3',
  },
})

export default MultiSliderDefaultMarker
